import React from 'react';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactComponent as ImageIcon } from '../../../../resources/svg/image.svg';

const Root = styled(Grid)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	backgroundColor: theme.palette.surface.main
}));

const Icon = styled(ImageIcon)(({ theme }) => ({
	stroke: theme.palette.surface.contrast,
	width: '50%',
	height: 'auto'
}));

function ImagePlaceholder({ ...props }) {
	return (
		<Root {...props}>
			<Icon />
		</Root>
	);
}

export default ImagePlaceholder;
